export function displayError(err: Error) {
	if (err?.message) {
		// TODO: make toastr?
		console.error(err.message);
	}
}